var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "orderNowWrapper",
      class: { fixOrderNow: !_vm.$store.getters.isKiosk },
    },
    [
      _c("v-container", { staticClass: "pointer cc" }, [
        _c("div", { staticClass: "d-flex align-content-stretch" }, [
          _c(
            "div",
            {
              staticClass: "leftPart flex50 text-center",
              class: {
                rounderRight: _vm.$store.getters.orderingEnabled === false,
              },
              on: {
                "&click": function ($event) {
                  return _vm.$emit("more")
                },
              },
            },
            [
              _c("div", { staticClass: "maxh superCenter mehr" }, [
                _c("div", [_vm._v("Mehr hinzufügen")]),
              ]),
            ]
          ),
          _vm.$store.getters.orderingEnabled
            ? _c(
                "div",
                {
                  staticClass: "rightPart flex50 text-center orderPulsing",
                  on: {
                    "&click": function ($event) {
                      return _vm.clickRight.apply(null, arguments)
                    },
                  },
                },
                [
                  _vm.isSimpleCase
                    ? _c(
                        "div",
                        {
                          staticClass:
                            "maxh d-flex justify-center align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1 myWhite",
                              attrs: { left: "" },
                            },
                            [_vm._v("mdi-send")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "ml-1 titleFont",
                              staticStyle: { color: "white" },
                            },
                            [_vm._v(" Jetzt Bestellen ")]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "div",
                        {
                          staticClass:
                            "maxh d-flex justify-center align-center",
                        },
                        [
                          _c(
                            "v-icon",
                            {
                              staticClass: "mr-1 myWhite",
                              attrs: { left: "" },
                            },
                            [_vm._v("mdi-cart-arrow-right")]
                          ),
                          _c(
                            "div",
                            {
                              staticClass: "ml-1 titleFont",
                              staticStyle: { color: "white" },
                            },
                            [
                              _vm.$store.getters.isKiosk
                                ? _c("span", [_vm._v("Bestätigen")])
                                : _c("span", [_vm._v("Bestätigen")]),
                            ]
                          ),
                        ],
                        1
                      ),
                ]
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }